var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "open_in_new_black_24dp_1_",
    "data-name": "open_in_new_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.596,
    height: 27.596,
    viewBox: "0 0 27.596 27.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_379306",
    "data-name": "Path 379306",
    d: "M0,0H27.6V27.6H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_379307",
    "data-name": "Path 379307",
    d: "M21.4,21.4H5.3V5.3h8.049V3H5.3A2.3,2.3,0,0,0,3,5.3V21.4a2.3,2.3,0,0,0,2.3,2.3H21.4a2.306,2.306,0,0,0,2.3-2.3V13.348H21.4ZM15.648,3V5.3h4.128L8.473,16.6l1.621,1.621,11.3-11.3v4.128h2.3V3Z",
    transform: "translate(0.449 0.449)",
    fill: "#AF2C1B",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenNewTab);
export default __webpack_public_path__ + "static/media/open_New_Tab.4a20b71a5ee59980d642a0b634c9a3a4.svg";
export { ForwardRef as ReactComponent };